import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=557c37ad&scoped=true"
import script from "./notice-detail.vue?vue&type=script&lang=js"
export * from "./notice-detail.vue?vue&type=script&lang=js"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=557c37ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c37ad",
  null
  
)

export default component.exports